import React, { useEffect, useState } from 'react';
import { getRequest, deleteRequest, putRequest } from 'apis/ApiInstence';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';

const ListCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const res = await getRequest('download-categories');
            setCategories(res?.data || []);
        } catch (err) {
            console.error('Failed to fetch categories:', err);
            toast.error("Failed to load categories list.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this category?")) {
            try {
                await deleteRequest(`download-categories/${id}`);
                toast.success("Category deleted successfully!");
                fetchCategories(); // Refresh list
            } catch (err) {
                console.error(err);
                toast.error("Failed to delete category.");
            }
        }
    };

    const handleToggleStatus = async (category) => {
        try {
            await putRequest(`download-categories/${category.id}`, { is_active: !category.is_active });
            toast.success("Category status updated!");
            fetchCategories();
        } catch (err) {
            console.error(err);
            toast.error("Failed to update status.");
        }
    };

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Category Name',
            accessor: 'name',
            Cell: ({ row }) => (
                <div className="text-left font-weight-bold">
                    {row.original.name}
                </div>
            )
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <button 
                    className={`btn btn-sm ${row.original.is_active ? 'btn-success' : 'btn-secondary'}`}
                    onClick={() => handleToggleStatus(row.original)}
                    style={{ width: '80px', borderRadius: '20px' }}
                >
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </button>
            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div className="d-flex justify-content-center">
                    <button className="btn btn-sm btn-danger mx-1" title="Delete" onClick={() => handleDelete(row.original.id)}>
                        <FaTrash />
                    </button>
                </div>
            )
        }
    ];

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <div className="container-fluid mt-4">
            <div className="dashboard-header-card d-flex align-items-center justify-content-between mb-4 mx-2 shadow-lg" style={{ background: 'linear-gradient(135deg, #0054A6 0%, #007BFF 100%)', borderRadius: '15px', padding: '1.5rem 2rem' }}>
                <div className="d-flex align-items-center">
                    <div className="icon-circle mr-3" style={{ background: 'rgba(255,255,255,0.2)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-download text-white" style={{ fontSize: '24px' }}></i>
                    </div>
                    <div>
                        <h3 className="text-white font-weight-bold mb-0" style={{ letterSpacing: '0.5px' }}>Download Categories</h3>
                        <p className="text-white-50 mb-0 small">Manage dynamic categories for website downloads</p>
                    </div>
                </div>
                <div>
                    <Link to="/downloads/categories/add" className="btn btn-light font-weight-bold shadow-sm" style={{ borderRadius: '8px', padding: '0.6rem 1.2rem', color: '#0054A6' }}>
                        <i className="fa fa-plus mr-2"></i>
                        Add Category
                    </Link>
                </div>
            </div>

            {loading ? (
                <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="mx-2">
                    <AdminTable tableHeaders={tableHeaders} tableData={categories} />
                </div>
            )}
        </div>
    );
};

export default ListCategories;
